import { Job, JobDetail, JobParams, JobStatusCount } from 'types/job'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import { MpEmploymentJobDetail } from 'types/mp_employment_job'
const resource = 'jobs'

export const requests = {
  // paramsいずれかの条件に一致する募集を検索（OR条件）
  fetchJobs: async (params?: JobParams) => {
    return await axiosForGigbaseBiz.get<DataResponse<Job[]>>(resource, {
      params,
    })
  },
  // paramsすべての条件に一致する募集を検索（AND条件）
  fetchSearchJobs: async (params?: JobParams) => {
    return await axiosForGigbaseBiz.get<DataResponse<Job[]>>(
      mergeURL(resource, 'search'),
      { params },
    )
  },
  fetchJob: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<JobDetail>>(
      mergeURL(resource, id),
    )
  },
  fetchMpEmploymentJobDetail: async (id: string) => {
    return await axiosForGigbaseBiz.get<
      DataResponse<JobDetail<MpEmploymentJobDetail>>
    >(mergeURL(resource, id.toString()))
  },
  fetchJobStatusCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<JobStatusCount>>(
      mergeURL(resource, 'count'),
    )
  },
}
